import { Dispatch } from 'redux';
import { AxiosResponse } from 'axios';
import { DispatchFunction, IWorkflowRequest, IActiveFilter } from '@app/models';
import { GET_ALL_WORKFLOW_REQUEST, GET_ALL_WORKFLOW_REQUEST_LOADING, SET_WORKFLOW_REQUEST_COUNT } from '@app/store/constants';
import { workflowRequestService } from '@app/services';
import { loadingData } from '@app/store/actions';

export function handleGetWorkflowRequestsData(orderBy: string, asc: string, top: number, skip: number, organizationId: string, isReset: boolean, filters?: IActiveFilter[]): DispatchFunction {
    return ((dispatch: Dispatch) => {
        if (isReset) {
            dispatch(loadingData(true));
            dispatch(getAllWorkflowRequests([]));
            dispatch(setWorkflowRequestsCount(0));
        }
        
        workflowRequestService.getWorkflowRequests(orderBy, asc, top, skip, organizationId, isReset, filters)
            .then((response: AxiosResponse) => {
                dispatch(getAllWorkflowRequests(response.data.value));

                if (isReset) {
                    dispatch(setWorkflowRequestsCount(response.data['@odata.count']));
                    dispatch(loadingData(false));
                }
            })
            .catch(() => {
                dispatch(loadingData(false));
            });;
    });
};

export function getAllWorkflowRequests(workflowRequests: IWorkflowRequest[]) {
    return {
        payload: workflowRequests,
        type: GET_ALL_WORKFLOW_REQUEST
    };
};

export function getAllWorkflowRequestsLoading(workflowRequestsLoading: boolean) {
    return {
        payload: workflowRequestsLoading,
        type: GET_ALL_WORKFLOW_REQUEST_LOADING
    };
};

export function setWorkflowRequestsCount(count: number) {
    return {
        payload: count,
        type: SET_WORKFLOW_REQUEST_COUNT
    };
};